// Share and dashboard links carry bearer tokens in these path segments (a reel's segment
// under `/p/<link>/reels/` is a share token on shared reel pages). Shared by the browser
// logger and by modules that log author-entered URLs from server and client code.
export const TOKEN_PATH_SEGMENT =
  /(\/(?:reels\/share|reels|recruitment-dashboard)\/)[^/?#]+/;

export const redactTokenPathSegments = (path: string): string =>
  path.replace(TOKEN_PATH_SEGMENT, "$1[redacted]");
